export default class FilterSelect {
    constructor() {
        this.forms = document.querySelectorAll(".filter-select-form");

        if (!this.forms.length) {
            return;
        }

        this.initFilterSelect();
    }

    initFilterSelect() {
        // RGAA 7.4 : la navigation se déclenche à la validation explicite du formulaire
        // (bouton « Filtrer »), et non plus au changement du select.
        this.forms.forEach(form => {
            form.addEventListener("submit", (e) => {
                e.preventDefault();
                const select = form.querySelector("select");
                if (select && select.value) {
                    window.location = select.value;
                }
            });
        });
    }
}
